import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Shield, Database, Smartphone } from 'lucide-react';

const HealthcareServices = () => {
  const solutions = [
    {
      icon: <Heart size={40} />,
      title: 'Digital Health Platforms',
      description: 'Comprehensive digital health solutions for patient engagement and care management.',
      features: ['Telemedicine platforms', 'Patient portals', 'Mobile health apps', 'Wearable integration']
    },
    {
      icon: <Shield size={40} />,
      title: 'Healthcare Security',
      description: 'HIPAA-compliant security solutions protecting sensitive patient data and medical records.',
      features: ['HIPAA compliance', 'Data encryption', 'Access controls', 'Audit trails']
    },
    {
      icon: <Database size={40} />,
      title: 'Health Data Analytics',
      description: 'Advanced analytics for population health management and clinical decision support.',
      features: ['Clinical analytics', 'Population health', 'Predictive modeling', 'Real-world evidence']
    },
    {
      icon: <Smartphone size={40} />,
      title: 'Healthcare IoT',
      description: 'Connected medical devices and IoT solutions for remote patient monitoring.',
      features: ['Remote monitoring', 'Medical IoT', 'Real-time alerts', 'Device integration']
    }
  ];

  return (
    <div className="service-page">
      <div className="container">
        <motion.div 
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Healthcare & Life Sciences</h1>
          <p>Transform healthcare delivery with digital solutions, data analytics, and secure platforms.</p>
        </motion.div>

        <div className="services-grid">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <div className="service-icon">{solution.icon}</div>
              <h3>{solution.title}</h3>
              <p>{solution.description}</p>
              <ul>
                {solution.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HealthcareServices;